import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'noneMatch' })
export class NoneMatchPipe implements PipeTransform {
  transform(entries: any[] = [], predicate: (any) => boolean = () => false): any {
    return !entries.some(predicate);
  }
}
